export default __webpack_public_path__ + "static/media/4.064ea1d9.png";